import '.g5{padding:0px;}.ssr-plugin'
import '.az{appearance:none;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.dq{top:0px;}.ssr-plugin'
import '.z{bottom:0px;}.ssr-plugin'
import '.dp{left:0px;}.ssr-plugin'
import '.dr{right:0px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a8{background:transparent;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.x{border:none;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { TEXT_VARIANT_STYLES } from '../../tokens/typography.js'

type OneTimePasswordInputProps = {
  value?: string
  onChange: (value: string) => void
  passwordLength?: number
  error?: boolean
  disabled?: boolean
}

function OneTimePasswordInput({
  passwordLength = 6,
  value,
  onChange,
  error,
  disabled,
}: OneTimePasswordInputProps) {
  const ref = useRef<HTMLInputElement>()
  const [focused, setFocused] = useState(false)

  useLayoutEffect(() => {
    if (!ref.current) return

    ref.current.focus()
  }, [])

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        gap: 16,
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        ...(!disabled && {
          cursor: 'text',
        }),
      }}
    >
      {Array.from({ length: passwordLength }).map((_, i) => (
        <div
          key={i}
          style={{
            pointerEvents: 'none',
            width: '100%',
            height: 36,
            minWidth: 36,
            border: `1px solid ${colors.neutral20}`,
            borderRadius: radius[12],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: colors.neutral100,
            ...(error && {
              color: colors.neutral100,
              border: `1px solid ${colors.red80}`,
            }),
            ...(disabled && {
              color: colors.neutral20,
              background: colors.neutral5,
              border: `1px solid transparent`,
            }),
            ...(focused &&
              i === value?.length && {
                border: '1px solid transparent',
              }),
          }}
        >
          {i === passwordLength &&
          focused &&
          value?.length === passwordLength ? null : (
            <Text variant="display-medium" color="inherit">
              {value?.[i]}
            </Text>
          )}
        </div>
      ))}
      <styled.input className="g5 az p dq z dp dr h a8 b5 x fk"
        ref={ref}
        value={
          focused && value?.length === passwordLength
            ? (value?.at(-1) ?? '')
            : ''
        }
        onChange={(e) => {
          if (value?.length >= passwordLength) return

          onChange(`${value ?? ''}${e.target.value}`)
        }}
        onFocus={() => {
          setFocused(true)
        }}
        onBlur={() => {
          setFocused(false)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            const str = value ?? ''
            onChange(str.substring(0, str.length - 1))
          }
        }}
        disabled={disabled}
        maxLength={1}
        style={{
          ...(focused === true && {
            top: 0,
            bottom: 0,
            width: `calc((100% - (${passwordLength} - 1) * 16px ) / ${passwordLength})`,
            ...(value?.length < passwordLength && {
              left: `calc(((100% - (${passwordLength} - 1) * 16px ) / ${passwordLength}) * ${value?.length} + (16px * ${value?.length}))`,
            }),
            ...(value?.length === passwordLength && {
              left: 'unset',
              right: 0,
            }),
          }),
          borderRadius: radius[12],
          color: colors.neutral100,
          ...TEXT_VARIANT_STYLES['display-medium'],
          ...(focused && {
            border: `1px solid ${colors.neutral100}`,
            outline: `4px solid ${colors.neutral20}`,
          }),

          ...(focused &&
            error && {
              border: `1px solid ${colors.red100}`,
              outline: `4px solid ${colors.red60}`,
            }),
          ...(disabled && {
            border: `1px solid transparent`,
            outline: 'none',
            color: colors.neutral20,
          }),
        }}
      />
    </div>
  )
}

export type { OneTimePasswordInputProps }
export { OneTimePasswordInput }
